import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories } from '@/mocks/categories';

export default function CategoriesPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="w-full px-4 md:px-6 py-12 bg-background-50">
          <div className="max-w-[1200px] mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">全部分类</span>
            </nav>

            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
                全部分类
              </h1>
              <p className="text-foreground-500 text-sm max-w-[500px] mx-auto">
                12个精心分类，覆盖设计、开发、AI、学习等热门领域
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/category/${category.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                    <i className={`${category.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-foreground-900 font-semibold text-base mb-1.5 font-heading">
                    {category.name}
                  </h3>
                  <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2 mb-3">
                    {category.description}
                  </p>
                  <span className="text-primary-500 text-xs font-medium">
                    {category.resourceCount} 个资源
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}